import { FC, ReactNode } from "react";
import arrowIcon from "../../icons/arrow.png";
import styles from "./Games.module.scss";

export interface IGameBlockProps {
    handler?: () => void,
    icon: string;
    name: string | ReactNode;
}

export const GameBlock: FC<IGameBlockProps> = ({ handler, name, icon }) => {
    return (
        <div
            className={styles.gameItem}
            onClick={ handler }
        >
            <div className={styles.iconWrapper}>
                <img
                    src={icon}
                    alt={name?.toString()}
                    className={styles.icon}
                />                
            </div>

            <div className={styles.gameDetails}>
                <h3 className={styles.gameTitle}>{name}</h3>
            </div>

            <img src={arrowIcon} alt="arrow" className={styles.arrowIcon} />
        </div>
    );
}